import AppStoreH from "./AppStoreH"
import AboveAppstoreH from "./aboveappH";
import MainCart from "./mainContCart";
function Cart(){
    return(
       <>
       <MainCart/>
       <AboveAppstoreH/>
       <AppStoreH/>
       </>
    )
}

export default Cart;